import { render } from "./TelkomZaPrizes.vue?vue&type=template&id=e5f186e6&scoped=true"
import script from "./TelkomZaPrizes.vue?vue&type=script&lang=js"
export * from "./TelkomZaPrizes.vue?vue&type=script&lang=js"

import "./TelkomZaPrizes.vue?vue&type=style&index=0&id=e5f186e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f186e6"]])

export default __exports__